import React from 'react';
import reactions from 'Assets/reports/reactions.jpg';

export default function ReactionImage(props) {
  return (
    <div className='reactionImageWrapper'>
      <img src={reactions} className='reactionImage' />
    </div>
  )
}